"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NewPassword["default"];
  }
});
var _NewPassword = _interopRequireDefault(require("./NewPassword"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }